import { mapActions, mapGetters } from "vuex";
import { storeGetters } from "../store/storeGetters.constant";
import { exportContactCard } from "@/common/utils/vCard";
import { storeAction } from "@/store/storeActions.constant";
import { memberProfileConstants } from "@/components/MemberProfile/memberProfile.constants";

export default {
    data() {
        return {
            mobileAppDownloadErrors: [],
        };
    },
    methods: {
        ...mapActions({
            getVCardDetails: `memberProfile/${storeAction.getVCardDetails}`,
            getUserProfileInformation: `memberProfile/${storeAction.getUserProfileWithoutWrapper}`,
        }),
        downloadContactInfo(userId) {
            /* eslint-disable no-undef */
            if (this.isAndroidAppBrowser) {
                if (window && window.appInterface) {
                    const androidInterface = window.appInterface;
                    androidInterface.postMessage(userId);
                } else {
                    this.mobileAppDownloadErrors.push(userId);
                }
            } else if (this.isIosAppBrowser) {
                if (window && window.webkit) {
                    const iosInterface = window.webkit.messageHandlers.callback;
                    iosInterface.postMessage(userId);
                } else {
                    this.mobileAppDownloadErrors.push(userId);
                }
            } else {
                this.getUserProfileInformation(userId).then(this.getVCardDetails(userId)
                    .then(() => {
                        exportContactCard(this.vCardDetails, this.userProfile.firstName || 'contact_info');
                    })
                    .catch(() => {
                        console.log(memberProfileConstants.ERROR_VCARD);
                    }));
            }
            /* eslint-enable no-undef */
        },
        removeErrorDownload(userId) {
            this.mobileAppDownloadErrors = this.mobileAppDownloadErrors.filter(item => item !== userId);
        },
        hasErrorDownloadingInMobile(userId) {
            return this.mobileAppDownloadErrors.length
                && this.mobileAppDownloadErrors.some(item => item === userId);
        },
    },
    computed: {
        ...mapGetters({
            vCardDetails: `memberProfile/${storeGetters.vCardDetails}`,
            userProfile: `memberProfile/${storeGetters.userProfile}`,
            isAndroidAppBrowser: `${[storeGetters.isAndroidAppBrowser]}`,
            isIosAppBrowser: `${[storeGetters.isIosAppBrowser]}`,
        }),
    },
};
